import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Mail, Calendar } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#2F1B10] text-white py-16 border-t border-[#8B4513]" data-id="element-68">
      <div className="container mx-auto px-4 md:px-6" data-id="element-69">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-70">
          <div data-id="element-71">
            <h3 className="text-2xl font-bold mb-6 font-serif text-[#F4A460]" style={{
            fontFamily: 'Rockwell, "Courier New", serif'
          }} data-id="element-72">
              Commerce CFO <br data-id="element-73" />
              Roundtable - Austin
            </h3>
            <p className="text-gray-400 leading-relaxed" data-id="element-74">
              Presented by ECOM CFO & ECOM CPA — an exclusive gathering of
              finance leaders from the ecommerce industry. Insights, networking,
              and authentic Texas BBQ.
            </p>
          </div>

          <div data-id="element-75">
            <h3 className="text-xl font-bold mb-6 text-[#FFF8DC]" data-id="element-76">
              Quick Links
            </h3>
            <ul className="space-y-3 text-gray-400" data-id="element-77">
              <li data-id="element-78">
                <Link to="/" className="hover:text-[#D2691E] transition-colors flex items-center gap-2" data-id="element-79">
                  <span className="w-1.5 h-1.5 bg-[#D2691E] rounded-full" data-id="element-80"></span>
                  Home
                </Link>
              </li>
              <li data-id="element-81">
                <Link to="/sponsorship" className="hover:text-[#D2691E] transition-colors flex items-center gap-2" data-id="element-82">
                  <span className="w-1.5 h-1.5 bg-[#D2691E] rounded-full" data-id="element-83"></span>
                  Sponsorship
                </Link>
              </li>
              <li data-id="element-84">
                <a href="#register" className="hover:text-[#D2691E] transition-colors flex items-center gap-2" data-id="element-85">
                  <span className="w-1.5 h-1.5 bg-[#D2691E] rounded-full" data-id="element-86"></span>
                  Register
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-87">
            <h3 className="text-xl font-bold mb-6 text-[#FFF8DC]" data-id="element-88">
              Event Details
            </h3>
            <ul className="space-y-4 text-gray-400" data-id="element-89">
              <li className="flex items-start gap-3" data-id="element-90">
                <Calendar className="text-[#D2691E] mt-1" size={18} data-id="element-91" />
                <span data-id="element-92">
                  Summer 2026 (To Be Announced)
                  <br data-id="element-93" />
                  Two-Day Event
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-94">
                <MapPin className="text-[#D2691E] mt-1" size={18} data-id="element-95" />
                <span data-id="element-96">
                  East Austin, Texas
                  <br data-id="element-97" />
                  Franklin Barbecue Dinner
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-98">
                <Mail className="text-[#D2691E] mt-1" size={18} data-id="element-99" />
                <span data-id="element-100">info@commercecfotable.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#8B4513] mt-16 pt-8 text-center text-gray-500 text-sm" data-id="element-101">
          <p data-id="element-102">© 2026 Commerce CFO Roundtable. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}